import React from 'react'
import { Link } from 'react-router-dom'
import depresion from '../assets/images/psicologo/depresion.jpg'
import Navbar from '../components/navbar'
import Shape from '../components/shape'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer'
import bg_ansiedad from '../assets/images/psicologo/bg_ansiedad.jpg'
import bg1 from '../assets/images/bg.jpg'

export default function PageTerm() {
  return (
    <>
     <Navbar/>
     
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${depresion})`, backgroundPosition:'center'}}>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title text-white">Depresión</h4>
                          <p className="text-muted mb-0">Definición, síntomas y tratamientos</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="fw-bold text-white">Inicio</Link></li>
                          <li className="list-inline-item"><Link to="#" className="fw-bold text-white">Lo que tratamos</Link></li>
                          <li className="list-inline-item">
                              <span className="text-primary fw-bold">Depresión</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row justify-content-center" style={{textAlign:'justify', padding:20}}>
              <div className="col-12">
                  <h4>Introducción</h4>
                  <p className="text-muted">La depresión es un trastorno del estado de ánimo que va más allá de la tristeza pasajera. Se caracteriza por sentimientos persistentes de vacío, desesperanza o pérdida de interés en actividades que antes resultaban placenteras. Cuando estos síntomas son intensos, prolongados y afectan de forma significativa la vida diaria, se habla de un trastorno depresivo.</p>
                  <br />
                  <h4 className='text-warning'>¿Qué es la depresión?</h4>
                  <p className="text-muted">La depresión puede manifestarse de diversas formas, afectando el cuerpo, la mente y el comportamiento. Es diferente de las fluctuaciones normales del estado de ánimo. Factores biológicos, genéticos, psicológicos y sociales contribuyen a su desarrollo. Desde la neuromodulación, se sabe que este trastorno está relacionado con una actividad anormal en áreas del cerebro encargadas de regular las emociones, y que mediante técnicas específicas es posible favorecer un funcionamiento más equilibrado.
                </p>             
                  
                <br />               
                      <h4>Síntomas comunes</h4>
                      <p className="text-muted"> <i className="mdi mdi-chevron-double-right me-2"></i>Físicos: fatiga o pérdida de energía, alteraciones en el sueño (insomnio o dormir en exceso), cambios en el apetito y el peso, molestias físicas sin causa aparente.</p>
                      <p className="text-muted"> <i className="mdi mdi-chevron-double-right me-2"></i>Cognitivos: dificultad para concentrarse o tomar decisiones, sentimientos de inutilidad o culpa excesiva, pensamientos recurrentes de muerte o suicidio.</p>
                      <p className="text-muted"> <i className="mdi mdi-chevron-double-right me-2"></i>Conductuales: aislamiento social, pérdida de interés en actividades habituales, disminución del rendimiento en el trabajo o estudios.</p>
                     
                     
<br />     

                  <h4>Neuromodulación</h4>
                 <p className="text-muted"> <i className="mdi mdi-chevron-double-right me-2"></i>Estimulación Magnética Transcraneal (EMT): activa áreas cerebrales relacionadas con el estado de ánimo.</p>
                 <p className="text-muted"> <i className="mdi mdi-chevron-double-right me-2"></i>Estimulación Transcraneal por Corriente Directa (tDCS): modula la actividad neuronal para mejorar la regulación emocional.</p>
                 <p className="text-muted"> <i className="mdi mdi-chevron-double-right me-2"></i>Neurofeedback: entrena al cerebro para autorregular su actividad mediante retroalimentación en tiempo real.</p>
                 
              </div>
          </div>
      </div>
    </section>    
    <Footer/>
    </>
  )
}
